<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/D8ETB7/images/cover.jpg?1685327252829" alt="This image is the cover for the book Unexpected, 2014 Daily Dose - Mended"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Unexpected, 2014 Daily Dose - Mended
      </h1>
      <p class="bookDescription body article font2">
        <p>Unseelie are vicious, heartless, and cruel, or so Merin believes. Then Tarel, an Unseelie warrior, comes to his rescue, and turns his view of the world upside down.</p> <p>To escape the effects of his curse, Tarel exiled himself to the forest. He has enough issues with his own people, but he never thought he’d share his bed with a Seelie either, even if only by medical necessity. If Merin and Tarel can overcome their prejudices, they might see what a gift fate has given them.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        E.T. Malinowski
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?31f33d78